// extracted by mini-css-extract-plugin
export default {"billOfFare__filters":"FoodList_billOfFare__filters__a1LIJ"};